/*
Script by : Clem
---------------------------------------------
||        Manage projects (filters)        ||
---------------------------------------------
*/

jQuery(document).ready(function() {

    // if( jQuery('body').hasClass('page-template-template-soin') ){

    //     setSoinsTitlePosition();

    //     jQuery( window ).resize(setSoinsTitlePosition);

    //     function setSoinsTitlePosition(){
    //         if( jQuery(window).width() > 992 ){
    //             var featuredImageHeight = jQuery('.photo_container img').innerHeight() / 2;
    //             jQuery('.content .entry-header').css('marginTop', featuredImageHeight);
    //         } else {
    //             jQuery('.content .entry-header').css('marginTop', 0);
    //         }

    //     }

    // }

    // Gestion du clic sur un bloc soin
	jQuery('.bloc_soin').on('click', '.toggler', function() { 
        // Fermeture des autres blocs soins ouverts
        jQuery('.detail_soin').collapse('hide');
        jQuery('.detail_soin .close').click(function() { 
            jQuery('.detail_soin').collapse('hide');
        });
        
        // Smooth scroll après apparition du collapse
        setTimeout(() => {
            var page = jQuery(this).attr('href');
            //console.log(page);
            page = page.substring(page.indexOf("#"));
            scroll_level = jQuery(page).offset().top - 80;
            if(scroll_level > 0) {
                var speed = 500; // Durée de l'animation (en ms)
                jQuery('html, body').animate( { scrollTop: scroll_level }, speed );
            }
        }, 500);
    });

    // Gestion des filtres
    //jQuery('.filter_button').click(function (e) { 
        
    //});
});
